const $inject = ['$scope'];
const lbFiveStarRatingController = function ($scope) {

  let vm = this;

  if (vm.rating % 1 != 0) {
    vm.isDecimal = true;
  }

  vm.stars = Math.ceil(vm.rating);
};

lbFiveStarRatingController.$inject = $inject;

export default lbFiveStarRatingController;



// WEBPACK FOOTER //
// ./src/components/lbFiveStarRating/lbFiveStarRatingController.js